import type { TMessages } from '@/types/TMessages'

export const messages = { buttonTitle: 'Читать статью' } satisfies TMessages
